var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-white border border-50 p-6 card mb-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }